import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { DatePipe } from '@angular/common';

import {FormGroup, FormControl, Validators, NgForm}  from '@angular/forms';
import { stringify } from '@angular/core/src/render3/util';
import { variable } from '@angular/compiler/src/output/output_ast';
import swal from 'sweetalert2';

@Component({
  selector: 'app-gl-transaction',
  templateUrl: './gl-transaction.component.html',
  styleUrls: ['./gl-transaction.component.css']
})
export class GlTransactionComponent implements OnInit {
  [x: string]: any;
  title:string;
  gltransaction:any={};
  yrfddata: any;
  yrfdopt: any;
  branchdt:any;
  brnchopt:any;
  b:any={};
  DateValues:string;
  gltransdt:any;
  logbranch:any;
  commonUrl : string;
  userName:any;
  data : any = {}
  LedgerNamesList : any = [];
  AcountTypelist : any = [];
  subLedgerList : any = [];

  display='none';

  constructor(private service:UserService,private datePipe:DatePipe)
  {
    this.logbranch=localStorage.getItem('BRANCH_ID');
    this.commonUrl = service.rootUrl;
    this.userName = localStorage.getItem('userName');
  }

  ngOnInit()
  {
    this.title="GL-Transaction Reports";
    this.yearset(2);
    this.getbranchd();
    this.getAccountType();
  }
  

  yearset(Branch:number)
  {
    debugger;
    this.yrfddata=this.service.Yearseting(Branch);
    this.yrfddata.subscribe(
      (yrfdres:any)=>
      {
        this.yrfdopt=Array.of(yrfdres);
      }
    )
  }

  openModalDialog(){
    this.display='block'; //Set block css
 }

 closeModalDialog(){
  this.display='none'; //set none css after close dialog
 }

 
 ChangeModId(MOD_Id){
   debugger;
  if(MOD_Id >=0){
   this.data = this.service.GetAllLedgerName1(MOD_Id);
   this.data.subscribe(
      (response: any) => {         
       this.LedgerNamesList= response;   
      })
  }                
}
  getbranchd()
  {
    debugger;
   this.branchdt=this.service.getbranch();
   this.branchdt.subscribe(
    (bresponse:any)=>{
      this.brnchopt=bresponse.BranchModels;
      console.log(bresponse.BranchModels);
    })
  }

  getAccountType()
  {
    debugger;
    this.data = this.service.GetAccountType();
    this.data.subscribe(
       (response: any) => {         
        this.AcountTypelist= response;  
   })
  }
  ChangeLCode(L_CODE){
    if(L_CODE >=0){
    this.data = this.service.GetSubLedger3(L_CODE);
    this.data.subscribe(
       (response: any) => {         
        this.subLedgerList= response;   
       }) 
      }          
   }

  getdatefun(indt:any)
  {
    this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }


  resetFormc(gltransaction? : NgForm){
    swal({
    title:'Are you sure?',
    text: "You want to Cancel this!",
  type: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: 'Yes, Clear it!'
  }).then((result) => {
  if (result.value) {
    swal(
     'Cleared!',
     'Your file has been Cleared.',
     'success'
    )
  if(gltransaction !=null)
  gltransaction.reset();
 this.gltransaction.curryear=null;
 this.gltransaction.chkledger='';
 this.gltransaction.seloptio='';
 this.gltransaction.actype=null;
 this.gltransaction.acledger=null;
 this.gltransaction.SbLedger=null;
 this.gltransaction.sumdet='';
 this.gltransaction.selbranch='';
 this.gltransaction.frmdate='';
 this.gltransaction.todate='';
 this.gltransaction.languagedet='';
 

}
});
}

resetForm(form?:NgForm)
{
 if(form!=null)
 {
  this.gltransaction.curryear=null;
 this.gltransaction.chkledger='';
 this.gltransaction.seloptio='';
 this.gltransaction.actype=null;
 this.gltransaction.acledger=null;
 this.gltransaction.SbLedger=null;
 this.gltransaction.sumdet='';
 this.gltransaction.selbranch='';
 this.gltransaction.frmdate='';
 this.gltransaction.todate='';
 this.gltransaction.languagedet='';
 }
 }


  gltransreport(curryear:number,chkledger:boolean,seloptio:string,sumdet:string,selbranch:number,frmdate:Date,todate:Date,actype:number,acledger:number,Sbledger:number,gltransaction:NgForm)
  {
    if(chkledger==undefined||null)
    chkledger=false ;
    document.getElementById('loader-spinner').style.display = "block";
    this.gltransdt=this.service.gltransreport(curryear,chkledger,seloptio,sumdet,selbranch,frmdate,todate,this.logbranch,this.chckbint(actype),this.chckbint(acledger),this.chckbint(Sbledger));
    this.gltransdt.subscribe(
     (gltranres:any)=>{
       
       this.callreport(seloptio,sumdet);
       document.getElementById('loader-spinner').style.display = "none";
       this.resetForm(gltransaction);
     })
  }
  

  callreport(seloptio:string,sumdet:string)
  {
    debugger;
    if(seloptio=="DayBook"||seloptio=="dayBook")
      {
        if(sumdet=="Summary")
        {
          this.Daybooksummary();
        }
        else if(sumdet=="Details")
        {
          this.Daybookdetail();
        }
      }
      if(seloptio=="optCashBook")
      {
        if(sumdet=="Summary")
        {
          this.cashscrollsuma3();
        }
        else if(sumdet=="Details")
        {
          this.cashscrolldeta3();
        }
      }
      if(seloptio=="optAdjustmen")
      {
        if(sumdet=="Summary")
        {
          this.cashscrollsuma3();
        }
        else if(sumdet=="Details")
        {
          this.adjustmentscolldet();
        }
      }
      if(seloptio  == "optRandD")
      {
        if(sumdet=="Summary")
        {
          this.RandDsummary();
        }
        else if(sumdet=="Details")
        {
          this.RandDsummary();  
        }
      }
    
  }
  chckbbol(arg:boolean)
  {
    if (arg!=null)
    {
      return true;
    }
    else
      return false;
  }
  
  chckbint(arg:number)
  {
    if (arg!=null)
    {
      return arg;
    }
    else
      return 0;
  }
   
  chckbstr(arg:string)
  {
    if (arg!=null)
    {
      return arg;
    }
    else
      return "0";
  }
 
  chckdt(arg:Date)
  {
    if (arg!=null)
    {
      return arg;
    }
  }

  Daybooksummary()
  {
    window.open(this.commonUrl+'/Reports/DayBook/summary/DayBooksummary.aspx?userName='+this.userName);
   }
   Daybookdetail()
   {
    window.open(this.commonUrl+'/Reports/DayBook/details/Daybokdet.aspx?userName='+this.userName);
    }
    cashscrolldeta3()
    {
      window.open(this.commonUrl+'/Reports/CashScroll/CashScrollDetail/CashScrolldetA3/CashScrolldetail.aspx?userName='+this.userName);
    }
    cashscrollsuma3()
    {
      window.open(this.commonUrl+'/Reports/CashScroll/CashScrollsummary/CashScrollsumA3/CashScrollsum.aspx?userName='+this.userName);
    }
    adjustmentscolldet()
    {
      debugger;
      window.open(this.commonUrl+'/Reports/Adjustmentscroll/Adjustmentscroll_det/Adjustmentscroll_detA4/AdjustmentScroll_details.aspx?userName='+this.userName+'&fromdt='+this.gltransaction.frmdate);
    }

    RandDsummary()
    {
      debugger;
      window.open(this.commonUrl+'/Reports/RandD/RandD_det/RandDReport.aspx?userName='+this.userName+'&fromdt='+this.gltransaction.frmdate);
    }

    public show1 :boolean = false;

    selectLedger(){
      this.show1 = !this.show1;
    }
}



// WEBPACK FOOTER //
// ./src/app/reports/gl-transaction/gl-transaction.component.ts